import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as moduleState from './state'
import { IStateData } from './state'
import store from 'src/store'
import * as moduleSelectors from './selectors'
import { actions as moduleActions } from './actions'
import moduleSagas from './sagas'
import { builderSagaCommunications } from 'src/helpers/redux'

export const emailSlice = createSlice({
  name: moduleState.PREFIX,
  initialState: moduleState.initialState,
  reducers: {
    setNotificationsAppendMore(
      state,
      action: PayloadAction<IStateData['notifications']>
    ) {
      state.data.notifications.items = [
        ...state.data.notifications.items,
        ...action.payload.items,
      ]
      state.data.notifications.nextCursor = action.payload.nextCursor
    },
    setNotificationsAppend(
      state,
      action: PayloadAction<IStateData['notifications']['items'][number]>
    ) {
      state.data.notifications.items = [
        action.payload,
        ...state.data.notifications.items,
      ]

      state.data.notificationsCount = (state.data.notificationsCount || 0) + 1
    },
    setNotifications(
      state,
      action: PayloadAction<IStateData['notifications']>
    ) {
      state.data.notifications = action.payload
    },
    setNotificationsCount(
      state,
      action: PayloadAction<IStateData['notificationsCount']>
    ) {
      state.data.notificationsCount = action.payload
    },
    setNotificationsMarkAsRead(
      state,
      action: PayloadAction<{ ids?: string[]; all?: boolean }>
    ) {
      if (action.payload.all) {
        state.data.notifications.items = state.data.notifications.items.map(
          (notif) => ({
            ...notif,
            isRead: true,
          })
        )
        state.data.notificationsCount = 0

        return
      }

      const ids = action.payload.ids || []
      state.data.notifications.items = state.data.notifications.items.map(
        (notif) => {
          return {
            ...notif,
            isRead: ids.includes(notif.id) ? true : notif.isRead,
          }
        }
      )

      state.data.notificationsCount = state.data.notifications.items.filter(
        (notif) => !notif.isRead
      ).length
    },
  },
  extraReducers: (builder) => {
    builderSagaCommunications<moduleState.IState>(builder, moduleActions)
  },
})

export const reducers = { [moduleState.PREFIX]: emailSlice.reducer }
export const selectors = moduleSelectors
export const setters = emailSlice.actions
export const actions = moduleActions
export const sagas = moduleSagas

export const injectStore = () => {
  store.injectReducer?.(moduleState.PREFIX, emailSlice.reducer)
  store.injectSaga?.(moduleState.PREFIX, sagas)
}
